import React from 'react'

const RatesCard = (props) => {
    return (
        <div className="rates-card" >
            <p className="deal-title" > {props.title} </p>
            <p className="deal-price">
                {
                    props.prevPrice ?
                        <div>
                            ${props.prevPrice}
                        </div>
                        :
                        null
                }
                {/* <span>{props.other ? null : "$" }</span>{props.overallPrice} */}
            </p>
            {props.other ? null : <p className="inc-p" > {/* INCL. LADIES FEE + ROOM HIRE */}</p>}
            <div className="feature-list">
                {
                    props.other ?
                        <div>
                            <p> <i class="far fa-check-circle"></i> Longer bookings can be accommodated </p>
                            <p> <i class="far fa-check-circle"></i> A variety of playmates offering a range of services and fantasies to fulfil your desires </p>
                            <p> <i class="far fa-check-circle"></i> Extra services to be negotiated with the Playmate directly</p>
                        </div>
                        : props.spa ?
                            <div>
                                <p> <i class="far fa-check-circle"></i> Upgrade to a spa experience </p>
                                <p> <i class="far fa-check-circle"></i> ${props.spaPrice} (including GST) additional room hire fee </p>
                            </div>
                            :
                            <div>
                                <p> <i class="far fa-check-circle"></i> Entry Level Service </p>
                                <p> <i class="far fa-check-circle"></i> Room Hire ${props.roomPrice} (Including GST)</p>
                                <p> <i class="far fa-check-circle"></i> Playmates Fee To Be Paid Directly To The Playmate ${props.ladyPrice} </p>
                                <p> <i class="far fa-check-circle"></i> Extra Services To Be Negotiated with Playmate Directly </p>
                            </div>
                }
            </div>
            <a href="tel:07%203426%208126" > <button> BOOK NOW </button> </a>
        </div>
    )
}

export default RatesCard